import React, { useRef, useState } from "react";
import ReactECharts from "echarts-for-react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

export default function InteractionChart() {
    const { t } = useTranslation();
    const chartRef = useRef<any>(null);

    const seriesNames = {
        interactions: t('overview_report.interactions'),
        customers: t('overview_report.new_customers'),
    };

    const [active, setActive] = useState({
        interactions: true,
        customers: true
    });

    const toggleSeries = (key: "interactions" | "customers") => {
        const name = seriesNames[key];
        const chart = chartRef.current.getEchartsInstance();

        chart.dispatchAction({
            type: "legendToggleSelect",
            name
        });

        setActive(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const option = {
        tooltip: {
            trigger: "axis"
        },

        legend: {
            show: false
        },

        grid: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 20,
            containLabel: true
        },

        xAxis: {
            type: "category",
            boundaryGap: false,
            data: [
                "01/03/2026",
                "02/03/2026",
                "03/03/2026",
                "04/03/2026"
            ]
        },

        yAxis: {
            type: "value"
        },

        series: [
            {
                name: seriesNames.interactions,
                type: "line",
                smooth: true,
                data: [1, 0, 1, 1],
                lineStyle: { width: 3 },
                symbol: "circle",
                symbolSize: 6,
                color: "#3b82f6"
            },
            {
                name: seriesNames.customers,
                type: "line",
                smooth: true,
                data: [0, 1, 3, 2],
                lineStyle: { width: 3 },
                symbol: "circle",
                symbolSize: 6,
                color: "#22c55e"
            }
        ]
    };

    return (
        <div>

            <div className="flex gap-3 mb-4">

                <Button
                    className={
                        active.interactions
                            ? "bg-[#3e91ab] text-white border-none"
                            : ""
                    }
                    onClick={() => toggleSeries("interactions")}
                >
                    {seriesNames.interactions}
                </Button>

                <Button
                    className={
                        active.customers
                            ? "bg-green-500 text-white border-none"
                            : ""
                    }
                    onClick={() => toggleSeries("customers")}
                >
                    {seriesNames.customers}
                </Button>

            </div>

            <ReactECharts
                ref={chartRef}
                option={option}
                style={{ height: 350 }}
            />

        </div>
    );
}